var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
const TextAreaInput = (_a) => {
    var { innerRef, onChange } = _a, props = __rest(_a, ["innerRef", "onChange"]);
    let classNames = props.className || "p-2 w-full";
    classNames += " border border-wfGray-300 focus:border-salmon-600 focus:border-2";
    return (_jsx("textarea", { onChange: (ev) => {
            if (props.allowedCharacters) {
                const newValue = ev.target.value.replace(new RegExp(`[^${props.allowedCharacters}]`, 'g'), '');
                ev.target.value = newValue;
                onChange(Object.assign(Object.assign({}, ev), { target: Object.assign(Object.assign({}, ev.target), { value: newValue }) }));
            }
            else {
                onChange(ev);
            }
        }, onKeyPress: (ev) => {
            if (props.allowedCharacters && !new RegExp(`^[${props.allowedCharacters}]$`).test(ev.key)) {
                ev.preventDefault();
            }
        }, defaultValue: props.value, ref: innerRef, className: classNames, placeholder: props.placeholder, disabled: props.disabled }));
};
export default TextAreaInput;
